"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
class Bubble extends React.PureComponent {
    constructor() {
        super(...arguments);
        this.getContent = () => {
            const { max, children } = this.props;
            const content = (max && parseInt(children, 10) > max) ? `${max}+` : `${children}`;
            return content;
        };
    }
    render() {
        return (React.createElement("div", { className: 'vf-bubble' }, this.getContent()));
    }
}
exports.default = Bubble;
